/*
  Homepage hero behaviour (PDP LAB, 19 Sep 2026). Markup: sections/kn-hero.liquid.
  Phones: crossfade between the two photos on a timer; the progress segments show
  where you are and can be tapped; paused while the hero is off screen or the tab
  is hidden; no timer at all with reduced motion.
  Desktop: the two photos drift a few dozen pixels at different speeds on scroll.
*/
(() => {
  if (customElements.get('kn-hero')) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const phone = window.matchMedia('(max-width: 989px)');

  class KnHero extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-knh-slide]')];
      this.segs = [...this.querySelectorAll('[data-knh-seg]')];
      this.interval = Number(this.dataset.interval) || 6500;
      this.style.setProperty('--knh-interval', `${this.interval}ms`);
      this.i = 0;
      this.show(0);
      this.segs.forEach((s) => s.addEventListener('click', () => { this.show(Number(s.dataset.knhSeg)); this.arm(); }));

      this.visible = true;
      new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; this.arm(); }, { threshold: 0.2 }).observe(this);
      document.addEventListener('visibilitychange', () => this.arm());
      phone.addEventListener?.('change', () => this.arm());
      this.arm();
      this.bindDepth();
      this.arrive();
    }

    // Split the headline into its rendered lines once, then play the arrival a single time.
    arrive() {
      if (reduce.matches || sessionStorage.getItem('knh-seen')) return;
      const h = this.querySelector('[data-knh-title]');
      if (!h) return;
      const words = h.textContent.trim().split(/\s+/);
      h.textContent = '';
      const spans = words.map((w) => { const s = document.createElement('span'); s.textContent = w + ' '; s.style.display = 'inline'; h.appendChild(s); return s; });
      const lines = [];
      spans.forEach((s) => { const top = s.offsetTop; const last = lines[lines.length - 1]; if (!last || Math.abs(last.top - top) > 4) lines.push({ top, words: [s.textContent] }); else last.words.push(s.textContent); });
      h.textContent = '';
      lines.forEach((l, i) => {
        const line = document.createElement('span');
        line.className = 'knh__line';
        line.style.setProperty('--l', i);
        const inner = document.createElement('span');
        // DESIGN 23 Sep 2026: keep the trailing space, or two lines that reflow onto one read "realAustralian".
        inner.textContent = l.words.join('');
        line.appendChild(inner);
        h.appendChild(line);
      });
      h.setAttribute('aria-label', words.join(' '));
      this.classList.add('is-arriving');
      setTimeout(() => this.classList.remove('is-arriving'), 2400); // hand back to the normal hero once played
      try { sessionStorage.setItem('knh-seen', '1'); } catch (e) {}
    }

    show(i) {
      this.i = i;
      this.slides.forEach((s, n) => s.classList.toggle('is-on', n === i));
      this.segs.forEach((s, n) => {
        s.classList.toggle('is-on', n === i);
        s.classList.toggle('is-done', n < i);
        const bar = s.querySelector('span');
        if (bar && n === i) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
    }

    arm() {
      clearTimeout(this.timer);
      const run = phone.matches && !reduce.matches && this.visible && !document.hidden;
      this.classList.toggle('is-paused', !run);
      if (!run) return;
      this.timer = setTimeout(() => { this.show((this.i + 1) % this.slides.length); this.arm(); }, this.interval);
    }

    bindDepth() {
      let raf = 0;
      const paint = () => {
        raf = 0;
        if (phone.matches || reduce.matches) {
          this.slides.forEach((s) => (s.style.transform = ''));
          return;
        }
        const r = this.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        const y = -r.top;
        this.slides.forEach((s) => {
          const d = Number(s.dataset.depth) || 0;
          s.style.transform = `translate3d(0, ${(y * d).toFixed(1)}px, 0)`;
        });
      };
      window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
      paint();
    }
  }

  customElements.define('kn-hero', KnHero);
})();
